import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
const dpeEndpoints = {
    get: 'services/public/dpe/partners/',
    vitality: {
        check: 'api/dpe/vitality/check',
    },
};
class DpeApi {
    constructor() {
        this.checkVitality = (eligibilityRequest, apiPrefix, defaultRequestParams) => {
            const axiosConfig = {
                data: eligibilityRequest,
                method: 'POST',
                params: defaultRequestParams,
                url: `${apiPrefix}${dpeEndpoints.vitality.check}`,
                withCredentials: true,
            };
            return axiosClient.request(axiosConfig);
        };
    }
    getPartner(apiPrefix, partner, path) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${apiPrefix}${dpeEndpoints.get}${partner}`,
                withCredentials: true,
                params: { path },
            };
            const dpeEndpointRequest = yield axiosClient.request(axiosConfig);
            return dpeEndpointRequest.data;
        });
    }
    getPartners(apiPrefix, path) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${apiPrefix}${dpeEndpoints.get}`,
                withCredentials: true,
                params: { path },
            };
            const dpeEndpointRequest = yield axiosClient.request(axiosConfig);
            return dpeEndpointRequest.data;
        });
    }
}
export default new DpeApi();
